import moment from 'moment';
import React, { Component } from 'react';
import classes from './PostDetailComments.module.css';
import Comment from 'containers/Comments/Comment/Comment';
import { isSameDay } from 'shared/calendar';
import { formatDateForPostDetails } from 'shared/utility';

class PostDetailComments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCommentId: null,
    };
  }

  updateActiveComment = (activeCommentId) => {
    this.setState({ activeCommentId });
  };

  render = () => {
    let commentsArray = this.props.comments && this.props.comments.length > 0 ? this.props.comments : null;
    let commentGroupId = null;
    commentsArray = commentsArray
      ? commentsArray.sort((a, b) => {
          if (moment(a.Date).isBefore(moment(b.Date))) {
            return -1;
          }
          if (a.Date === b.Date) {
            if (a.Comment.length > 0) {
              return -1;
            }
            if (a.File) {
              return 1;
            }
            if (a.Tags) {
              return 0;
            }
          } else {
            return 0;
          }
          return -1;
        })
      : [];

    const comments = commentsArray
      ? commentsArray.map((comment, index) => {
          const showCommentHeader = !!(!comment.ComGroupId || comment.ComGroupId !== commentGroupId);
          let displayDate = null;

          if (index === 0) {
            displayDate = <span className={classes.CommentDate}>{formatDateForPostDetails(comment.Date)}</span>;
          } else if (!showCommentHeader) {
            displayDate = null;
          } else if (index > 1 && isSameDay(comment.Date, commentsArray[index - 1].Date) === false) {
            displayDate = <span className={classes.CommentDate}>{formatDateForPostDetails(comment.Date)}</span>;
          }
          const returnedComment = (
            <div key={comment.Id}>
              {displayDate}
              <Comment
                addImageToPost={this.props.addImageToPost}
                addTagToPost={this.props.addTagToPost}
                renderCommentImage={this.props.renderCommentImage}
                postTags={this.props.postTags}
                closeContributeForm={this.props.closeContributeForm}
                contributeFormOpen={this.props.contributeFormOpen}
                classes="PostDetails"
                updateActiveComment={this.updateActiveComment}
                activeCommentId={this.state.activeCommentId}
                toggleDeleteCommentDialogue={this.props.toggleDeleteCommentDialogue}
                commentType="addComment"
                comment={comment}
                postId={this.props.postId}
                postingAs={this.props.postingAs}
                post={this.props.post}
                users={this.props.users}
                logId={this.props.logId}
                showCommentHeader={showCommentHeader}
              />
            </div>
          );
          commentGroupId = comment.ComGroupId;
          return returnedComment;
        })
      : null;
    return <div className={classes.PostCommentsContainer}>{comments ? <div className={classes.Comments}>{comments}</div> : null}</div>;
  };
}

export default PostDetailComments;
